// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"ManagerRow_userContainer_2ST7V","userIcon":"ManagerRow_userIcon_1VE57","userText":"ManagerRow_userText_18myS","row":"ManagerRow_row_6WpsZ"};